(function (XHR) {
    "use strict";

    var originalOpen = XHR.prototype.open;
    var originalSend = XHR.prototype.send;

    XHR.prototype.open = function (method, url, async, user, pass) {
        this._url = url; // Save the URL for later use
        originalOpen.call(this, method, url, async, user, pass);
    };

    XHR.prototype.send = function (data) {
        var url = this._url;
        let location = window.location.href;
        
        if (url.toLowerCase() === "https://9lnmneswpix6vkqsb4dhdjmm.fast.sparq.ai/v2".toLowerCase()) {
            let body;
            try {
                body = JSON.parse(data);
            } catch (error) {
                console.error("Error parsing XHR data as JSON:", error);
                // If parsing fails, just proceed to send the original data
                originalSend.call(this, data);
                return;
            }

            // Extract collection handle from URL if present
            let collectionHandle = null;
            if (location.includes("/collections/")) {
                collectionHandle = location.split("/collections/")[1].split("?")[0];
                if (collectionHandle === "") {
                    collectionHandle = null; // prevent empty string handle
                }
            }

            // Proceed only if we're not on a search page and collectionHandle is valid
            if (!location.includes("/search") && collectionHandle) {
                let collectionHandleFormatted = `sortOrderFor_${collectionHandle.replaceAll("-", "_")}`;

                let sorting = body.sort || [];

                // Remove any empty sortOrderFor_ entries
                sorting = sorting.filter(s => s !== "sortOrderFor_");

                // Add collection-specific sortOrder if not already included
                if (!sorting.includes(collectionHandleFormatted)) {
                    sorting.push(collectionHandleFormatted);
                }

                // Update the sort order
                body.sort = sorting;
            }

           
            if (body.filter) {
  body.filter += " AND NOT tags = 'UNLISTED'";
}

            // Convert the modified body back to a JSON string
            data = JSON.stringify(body);
        }
        // Proceed to send the (possibly modified) data
        originalSend.call(this, data);
    };
})(XMLHttpRequest);



// (function (XHR) {
//   "use strict";

//   var open = XHR.prototype.open;
//   var send = XHR.prototype.send;

//   XHR.prototype.open = function (method, url, async, user, pass) {
//     this._url = url;
//     open.call(this, method, url, async, user, pass);
//   };

//   XHR.prototype.send = function (data) {
//     var self = this;
//     var url = this._url;
   
//     if (
//       url &&
//       url.toLowerCase() ===
//         "https://9lnmneswpix6vkqsb4dhdjmm.fast.sparq.ai/v2".toLowerCase() //v2 link
//     ) {
//       const body = JSON.parse(data);
//       if(location.pathname.includes("/all")){  
//         body.sort.push("sortOrderFor_all");
//       }
//       data = JSON.stringify(body);
//     }
//     send.call(this, data);
//   };
// })(XMLHttpRequest);


function toggleFilter() {
  let x = document.querySelector(".sq-app.main");
  x.classList.toggle("sq-open");
}
function toggleClass() {
  let y = document.querySelector(".sq-app.main");
  y.classList.remove("sq-open");
}
function removeClass() {
  let z = document.querySelector(".sq-app.main");
  z.classList.remove("sq-open");
}

window.sq = window.sq || {};

// window.addEventListener("load", () => {
//   if (window.matchMedia("(max-width: 767px)").matches) {
//     document
//       .getElementById("Search-In-Modal")
//       .addEventListener("focusin", () => {
//         document.querySelector(".sq-dropdown-body").style.maxHeight = "100%";
//       });
//     document
//       .getElementById("Search-In-Modal")
//       .addEventListener("focusout", () => {
//         document.querySelector(".sq-dropdown-body").style.maxHeight = "0px";
//       });
//   }
// });

window.sq.initSearch = (store) => {
  store.search();
};

setTimeout(() => {
  if (document.querySelector(".sq-filter-main"))
    document.querySelector(".sq-filter-main").style.visibility = null;
  if (document.querySelector(".sparq-container"))
    document.querySelector(".sparq-container").style.visibility = null;
}, 200);

window.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    document.querySelector("footer").click();
  }
});

window.sq.config?.filters?.map((filter) => {
  if (filter.stFieldName == "system_tags") {
    filter.conditionType = "AND";
  }
});
setTimeout(() => {
  document.querySelector(".thb-quick-search").addEventListener("click", (e) => {
    document.querySelector(".sq-dropdown-sidebar").classList.add("active");
  });

  document.querySelector("[sq-name='q']").addEventListener("keypress", (event) => {
    if (event.key === "Enter") {
      // Cancel the default action, if needed
      event.preventDefault();
      // Trigger the button element with a click
      document.querySelector(".sq-dropdown-body .button.btn-blue").click();
    }
  });
}, 500);
